import { render, staticRenderFns } from "./TaxesList.vue?vue&type=template&id=6b9f41c6"
import script from "./TaxesList.vue?vue&type=script&lang=js"
export * from "./TaxesList.vue?vue&type=script&lang=js"
import style0 from "./TaxesList.vue?vue&type=style&index=0&id=6b9f41c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports